import { render, staticRenderFns } from "./DriverProfilePanel.vue?vue&type=template&id=078ac553&scoped=true&"
import script from "./DriverProfilePanel.vue?vue&type=script&lang=js&"
export * from "./DriverProfilePanel.vue?vue&type=script&lang=js&"
import style0 from "./DriverProfilePanel.vue?vue&type=style&index=0&id=078ac553&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078ac553",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078ac553')) {
      api.createRecord('078ac553', component.options)
    } else {
      api.reload('078ac553', component.options)
    }
    module.hot.accept("./DriverProfilePanel.vue?vue&type=template&id=078ac553&scoped=true&", function () {
      api.rerender('078ac553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/components/DriverProfilePanel.vue"
export default component.exports